import { useTheme } from '@sds-system/system';
import type { ColorCode } from '@sds-system/types';
import { getColorValue } from '@sds-system/utils';
import { getSpinnerId } from './Spinner.const';
import type { SpinnerProps } from './Spinner.types';

export const SpinnerPulse = ({ color, activeColor, variant, name, ...props }: SpinnerProps) => {
  const theme = useTheme();
  const { palette } = theme;

  const svgColor = getColorValue((color || palette.primary[100]) as ColorCode, theme);
  const svgActiveColor = getColorValue(
    (activeColor || palette.bg.interactive.primary) as ColorCode,
    theme,
  );

  const animateIdList = getSpinnerId(3, variant, name);

  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='12' cy='12' fill={svgColor} r='2'>
        <animate
          attributeName='r'
          begin={animateIdList[0]?.begin}
          dur='0.45'
          from='2'
          id={animateIdList[0]?.id}
          to='12'
        />
        <animate
          attributeName='r'
          begin={animateIdList[2]?.begin}
          dur='0.45'
          from='6'
          id={animateIdList[2]?.id}
          to='2'
        />
        <animate
          attributeName='fill-opacity'
          begin={animateIdList[0]?.begin}
          dur='0.45'
          from='1'
          id={animateIdList[0]?.id}
          to='0'
        />
      </circle>
      <circle cx='12' cy='12' fill={svgActiveColor} r='2'>
        <animate
          attributeName='r'
          begin={animateIdList[0]?.begin}
          dur='0.45'
          from='2'
          id={animateIdList[0]?.id}
          to='3.5'
        />
        <animate
          attributeName='r'
          begin={animateIdList[1]?.begin}
          dur='0.45'
          from='3.5'
          id={animateIdList[1]?.id}
          to='2'
        />
      </circle>
    </svg>
  );
};
